import router from '../router'
import {
  AuthenticationState,
  AuthenticatedUser,
} from '@/model/AuthenticationState'
import Vue from 'vue'
import axios from 'axios'

const lsUser = localStorage.getItem('user')

const user = lsUser ? JSON.parse(lsUser) : null

const initialState: AuthenticationState = user
  ? { signedIn: true, signingIn: false, user }
  : { signedIn: false, signingIn: false, user: null }

export const authentication = {
  namespaced: true,
  state: initialState,
  actions: {
    signIn(
      { dispatch, commit }: Record<any, any>,
      { email, password, rememberMe, api, returnTo }: Record<any, any>
    ) {
      commit('signInRequest', { email })

      return api
        .post('/login', { email, password, rememberMe })
        .then((response: any) => {
          const user = response.data
          localStorage.setItem('user', JSON.stringify(user))
          commit('signInSuccess', user)
          dispatch(
            'alert/success',
            'Signed in! Hello ' + user.firstname + '!',
            { root: true }
          )
          if (user.status === 'waiting_for_parent') {
            dispatch('parentConsentPopup/showPopup', {}, { root: true })
          }
          router.push(returnTo || '/')
        })
        .catch((err: any) => {
          commit('signInFailure')

          const code = err.response?.data?.code;

          if (code === 'VERIFICATION_REQUIRED_EXPIRED') {
            throw err;
          }

          if (err.response && err.response.data && err.response.data.message) {
            dispatch('alert/error', err.response.data.message, { root: true })
          } else {
            dispatch('alert/error', 'Something gone wrong.', { root: true })
          }
        })
    },
    signInSocial(
      { dispatch, commit }: Record<any, any>,
      { url, token, api, firstname, lastname, email }: Record<any, any>
    ) {
      commit('signInRequest', { email: token })

      return new Promise((resolve, reject) => {
        api
          .post(url, { token })
          .then((response: any) => {
            const user = response.data
            localStorage.setItem('user', JSON.stringify(user))
            commit('signInSuccess', user)
            dispatch(
              'alert/success',
              'Signed in! Hello ' + user.firstname + '!',
              { root: true }
            )
            if (user.status === 'waiting_for_parent') {
              dispatch('parentConsentPopup/showPopup', {}, { root: true })
            }
            router.push('/')
            resolve(true)
          })
          .catch((err: any) => {
            commit('signInFailure')
            if(err.response.status == 403){
              if (err.response && err.response.data && err.response.data.message) {
                dispatch('alert/error', err.response.data.message, { root: true })
              } else if (url === '/login-fb'){
                dispatch('alert/error', 'We couldn’t log you in with Facebook. Please choose another sign-in method.', { root: true })
              } else if (url === '/google-fb'){
                dispatch('alert/error', 'We couldn’t log you in with Google. Please choose another sign-in method.', { root: true })
              } else {
                dispatch('alert/error', 'Something gone wrong.', { root: true })
              }
            } else{
              dispatch(
                  'socialRegistration/socialRegister',
                  { firstname, lastname, email, token },
                  { root: true }
              )
              router.push('/sign-up')
            }

            resolve(true)
          })
      })
    },
    changeAvatar({ commit }: Record<any, any>, { avatar }: Record<any, any>) {
      const lsUser: string | null = localStorage.getItem('user')
      if (!lsUser) {
        return
      }
      const newUser = JSON.parse(lsUser)
      newUser.avatar = avatar
      localStorage.setItem('user', JSON.stringify(newUser))
      commit('signInSuccess', newUser)
    },
    changeName(
      { commit }: Record<any, any>,
      { firstname, lastname }: Record<any, any>
    ) {
      const lsUser: string | null = localStorage.getItem('user')
      if (!lsUser) {
        return
      }
      const newUser = JSON.parse(lsUser)
      newUser.firstname = firstname
      newUser.lastname = lastname
      localStorage.setItem('user', JSON.stringify(newUser))
      commit('signInSuccess', newUser)
    },
    changeNickname(
      { commit }: Record<any, any>,
      { nickname }: Record<any, any>
    ) {
      const lsUser: string | null = localStorage.getItem('user')
      if (!lsUser) {
        return
      }
      const newUser = JSON.parse(lsUser)
      newUser.nickname = nickname
      localStorage.setItem('user', JSON.stringify(newUser))
      commit('signInSuccess', newUser)
    },
    signOut(
      { dispatch, commit }: Record<any, any>,
      { api }: Record<any, any>,
    ) {
      api.post('/logout')
        .then(() => {
          router.push('/sign-in')
          localStorage.removeItem('user')
          commit('signOut')
          dispatch('alert/success', 'Bye!', { root: true })
        });
    },
    removeJWTSession({ dispatch, commit }: Record<any, any>,) {
      router.push('/sign-in')
      localStorage.removeItem('user')
      commit('signOut')
      dispatch('alert/success', 'Your session has expired. Please sign in again.', { root: true })
    },
    resendVerification(
      { dispatch, commit }: Record<any, any>,
      { email, api }: Record<any, any>){
      commit('resendingVerification', { email })

      return api
        .post('/resend-verification', { email })
        .then(() => {
          router.push('/sign-up-success')
        }).catch(() => {
          dispatch('alert/error', "Couldn't resend verification link", { root: true })
        })
    }
  },
  mutations: {
    signInRequest(state: AuthenticationState, user: AuthenticatedUser) {
      state.signingIn = true
      state.signedIn = false
      state.user = user
    },
    signInSuccess(state: AuthenticationState, user: AuthenticatedUser) {
      state.signingIn = false
      state.signedIn = true
      state.user = user
    },
    signInFailure(state: AuthenticationState) {
      state.signingIn = false
      state.signedIn = false
      state.user = null
    },
    signOut(state: AuthenticationState) {
      state.signingIn = false
      state.signedIn = false
      state.user = null
    },
    resendingVerification(state: AuthenticationState) {
      state.signingIn = false
      state.signedIn = false
      state.user = null
    },
  },
}
